<template>
  <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>生产管理</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span @click="goBack" class="cursor-pointer">工单</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;" v-if="mode == 'create'">创建工单</span>
            <span style="color:#000;font-weight:bold;" v-if="mode != 'create'">编辑工单</span>
          </el-breadcrumb-item>
      </el-breadcrumb>
      <el-form :model="form" class="user-search" label-width="108px" size="small" :rules="rules" ref="proForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="工单编号" prop="orderCode">
              <el-input size="small" v-model="form.orderCode" placeholder=" 请输入，忽略将自动生成" :disabled="mode!='create'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品" prop="productInfo.productCode">
              <el-select :key="keyIndex"  :disabled="mode != 'create'" v-model="form.productInfo.productCode" filterable placeholder="查找或添加新产品" style="width:calc(100% - 64px);" @change="productChanged" >
                <el-option
                  v-for="item in productOptions"
                  :key="item.productCode"
                  :label="item.productName"
                  :value="item.productCode">
                </el-option>
                <!-- <el-option value="addProduct">添加</el-option> -->
              </el-select>
              <!--<el-button type="text" class="left-default-margin">高级选择</el-button>-->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划数" prop="planNum">
              <el-input-number
              class="input-number"
              style="width: 100%;"
              v-model="form.planNum"
              controls-position="right"
              :min="1"
              placeholder="请填写"
              @change="planNumChange"
            ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划时间" prop="planTime">
              <el-date-picker
                style="width: 100%;"
                :clearable="false"
                v-model="form.planTime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="1"
                placeholder="请输入内容"
                v-model="form.remark">
              </el-input>
            </el-form-item>
          </el-col>


        </el-row>
        <FormItem :setList="setList" :form="form" :colSpan="8" :mode="mode" v-if="showChild"></FormItem>
      </el-form>
    </div>
    <div class="white-background">
      <el-row class="defult-row-margin">
        <el-col :span="6">
          <div class="default-title">生产任务</div>
        </el-col>
        <el-col :span="18" class="text-align-right" v-if="form.orderStatus == '未开始'">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="showDialog('productProgress')" plain>从工序中添加</el-button>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="showDialog('technology')" plain>从工艺路线中添加</el-button>
        </el-col>
      </el-row>

      <list-table ref="listTable" :formData="form" :mode="mode"></list-table>
      <div class="text-align-center top-large-margin">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary"  @click="save()" v-if="!disabled">保 存</el-button>
      </div>
    </div>
    <!-- 添加工序弹窗 -->
    <el-dialog title="添加工序" :visible.sync="dialog.visible && dialog.mode == 'productProgress'" width="50%" @close="closeProductProgress" :close-on-click-modal="false">
      <production-processes v-if="dialog.visible && dialog.mode == 'productProgress'" @done="closeProductProgress" ></production-processes>
    </el-dialog>
    <!-- 选择工艺路线 -->
    <el-dialog title="选择工艺路线" :visible.sync="dialog.visible && dialog.mode == 'technology'" width="50%" @close="closeTechnology" :close-on-click-modal="false">
      <choose-technology v-if="dialog.visible && dialog.mode == 'technology'" @done="closeTechnology" ></choose-technology>
    </el-dialog>
    <!-- 从模板中添加弹窗 -->
    <el-dialog title="从模板中添加" :visible.sync="dialog.visible && dialog.mode == 'templete'" width="30%" @close="closeTemplete" :close-on-click-modal="false">
      <templete-dialog v-if="dialog.visible && dialog.mode == 'templete'" @done="closeTemplete"></templete-dialog>
    </el-dialog>
    <!-- 保存为模板 -->
    <el-dialog title="保存为模板" :visible.sync="dialog.visible && dialog.mode == 'saveTemplete'" width="30%" @close="closeSaveTemplete" :close-on-click-modal="false">
      <save-templete v-if="dialog.visible && dialog.mode == 'saveTemplete'" @done="closeSaveTemplete"></save-templete>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { orderSave,customSetGetAll,productGetAll,technologyGetAllProcess} from '@/api/basicData'
import ListTable from '@/views/order/list-table.vue'
import ProductionProcesses from "@/views/order/dialogManage/production-processes.vue";
import TempleteDialog from "@/views/order/dialogManage/templete-dialog.vue";
import SaveTemplete from "@/views/order/dialogManage/save-templete.vue";
import ChooseTechnology from "@/views/order/dialogManage/choose-technology.vue";
import FormItem from "@/components/FormItem";

export default {
  props:['mode','userData','setList','editRow'],
  components: {
    ListTable,
    ProductionProcesses,
    TempleteDialog,
    SaveTemplete,
    ChooseTechnology,
    FormItem
  },
  data() {
    var checkUnitPrice = (rulr,value,callback) =>{
      var copyValue = value + ''
      if(value<=0){
        callback('工资单价必须大于0')
      }else{
        var arr = copyValue.split('.')
        if(arr.length == 2){
          if(arr[0].length > 10){
            callback('整数位最多支持10位数字')
          }else{
            if(arr[1].length > 6){
              callback('小数点后最多保留6位数字')
            }else{
              callback()
            }
          }
        }else if(arr.length == 1){
          if(arr[0].length > 10){
            callback('整数位最多支持10位数字')
          }else{
            callback()
          }
        }else{

        }
      }
    }
    return {
      disabled:false,
      form:{
        productInfo:{
          productCode:'',
          productName:'',
          specs:'',
        },
        planTime:[],
        planNum:'',
      },
      rules:{
        'productInfo.id': [{
            required: true,
            message: "请选择产品",
            trigger: "blur",
        },] ,
        planNum:[
        {
            required: true,
            message: "计划数不能为空",
            trigger: ['blur','change'],
        },
          {validator:checkUnitPrice, trigger: ['blur','change']}
        ],
        planTime:[{
            required: true,
            message: "请选择计划时间",
            trigger: ["blur",'change'],
        }] ,
        'productInfo.productCode':[{
            required: true,
            message: "请选择产品",
            trigger: ["blur",'change'],
        }] ,
      },
      productOptions: [],
      orderStatusOptions:[{
        label:'未开始',
        value:'未开始'
      },{
        label:'执行中',
        value:'执行中'
      },{
        label:'逾',
        value:'逾'
      },{
        label:'已结束',
        value:'已结束'
      }],
      customerOptions: [{
        value: '重要客户',
        label: '重要客户'
      }, {
        value: '一般客户',
        label: '一般客户'
      }, {
        value: '新客户',
        label: '新客户'
      }],
      weChatNotification: [{
        value: '是',
        label: '是'
      }, {
        value: '否',
        label: '否'
      }],
      imageUrl:'',
      dialog:{
        visible:false,
        mode:''
      },
      showChild:true,
      keyIndex:'0'
    }
  },
  created(){
    this.showChild = true;
    if(this.mode == 'create'){
      var curDate = moment().format('YYYY-MM-DD')
      var planStartTime = curDate + ' 00:00:00'
      var planEndTime = curDate + ' 23:59:59'
      this.form.planTime = [planStartTime,planEndTime]
      this.form.orderStatus = '未开始'
    }else{
      var form = JSON.parse(JSON.stringify(this.editRow))
      this.form = form;
      var planStartTime = this.editRow.planStartTime == null ?"":this.editRow.planStartTime;
      var planEndTime = this.editRow.planEndTime==null ? "" :this.editRow.planEndTime;
      this.$set(this.form,'planTime',this.editRow.planStartTime &&this.editRow.planEndTime?  [planStartTime,planEndTime]:[]) ;
      this.form.productInfo = {
        productCode:this.form.productCode,
        productName:this.form.productName
      }

    }
    this.getProduct()
    if(this.mode == 'view'){
      this.disabled = true
    }
  },
  mounted(){
    this.planNumChange(this.form.planNum);
  },
  methods: {
    // 查询所有产品
    getProduct(){
      this.productOptions = [];
      console.log(this.form);
      productGetAll(this.userData.factoryId).then(res => {
        if(res.code == 200){
          this.productOptions = res.data;

        }
      }).catch(err => {

      })
    },
    //
    cancel:function(){
      this.showChild = false;
      this.$emit('done',{type:'cancel'})
    },
    save:function(){

      this.$refs.proForm.validate((valid) => {
         if (valid) {

            var data = JSON.parse(JSON.stringify(this.form));
            data.factoryId = this.userData.factoryId;
            data.produceTasks = this.$refs.listTable.listData;
            data.updater =  this.userData.name + '(' + this.userData.account+')';
            if(this.mode == 'create'){
              data.creater = this.userData.name + '(' + this.userData.account+')';
            }
            data.planStartTime = this.form.planTime[0]
            data.planEndTime = this.form.planTime[1]
            console.log('data',data);
           orderSave(data).then(res => {
             if(res.code == 200){
               this.$message.success('保存成功')
               this.showChild = false;
               this.$emit('done',{type:'save'})
             }else{
               this.$message.error(res.msg)
             }
           }).catch(err => {
             this.$message.error(err)
           })
         }
     })
    },
    add(){},
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    closeProductProgress(options){
      if(options && options.type == 'save'){
        if(options.data && options.data.length!=0){
          this.$refs.listTable.changeData(options.data);
        }
      }
      this.colseCommon()
    },
    planNumChange(val){
      var list = this.$refs.listTable.$data.listData;
      console.log(list);
      for(var i = 0;i<list.length;i++){
        // if(list[i].type == "process"){
        // }
        list[i].planNum = Math.round(val * list[i].coefficient * 100) / 100 ;
      }
      this.$refs.listTable.updateData(list);
    },
    showDialog:function(options){
      this.dialog.visible = true
      this.dialog.mode = options
    },
    closeTemplete(){
      this.colseCommon()
    },
    closeTechnology(options){

      if(options && options.type == 'save' && options.data){
         technologyGetAllProcess(options.data.technologyCode,this.userData.factoryId).then(res => {
            if(res.code == 200){
              if(res.data){
                for(var i = 0;i<res.data.length;i++){

                  res.data[i].type = 'process';
                }
                this.$refs.listTable.changeData(res.data);
              }

            }else{
              this.$message.error('查询失败！')
            }
        })
        .catch(err => {
          this.$message.error(err)
        })
        // var processList = options.data.processList;
        // if(processList && processList.length!=0){
        //   this.$refs.listTable.changeData(processList)
        // }
      }
      this.colseCommon()
    },
    closeSaveTemplete(){
      this.colseCommon()
    },
    colseCommon(){
      this.dialog.visible = false
      this.dialog.mode = ''
    },
    showMenu(){
      this.$nextTick(_ => { this.$refs.selectChoose.toggleMenu(); });
    },
    clearCustomer(){
      this.form.customerType = ''
    },
    productChanged(val){

      var res = this.productOptions.filter(function(item){return item.productCode == val}.bind(this));
      if(res && res.length!=0){
        this.form.productInfo =JSON.parse(JSON.stringify(res))[0];
        this.keyIndex = new Date().getTime();
        // this.$set(this.form.productInfo,'productCode',this.form.productInfo['productCode']);
        // this.$set(this.form.productInfo,'productName',this.form.productInfo['productName']);

        // console.log('this.form.productInfo',this.form.productInfo);

        technologyGetAllProcess(this.form.productInfo.technologyCode,this.userData.factoryId).then(res => {
            if(res.code == 200){
              if(res.data){
                for(var i = 0;i<res.data.length;i++){

                  res.data[i].type = 'process';
                }
                this.$refs.listTable.changeData1(res.data);
              }

            }else{
              this.$message.error('查询失败！')
            }
        })
        .catch(err => {
          this.$message.error(err)
        })

      }
    },
    /**
     * 返回上一级
     */
     goBack(){
      this.showChild = false;
      this.$emit("goBack");
    },
  },
}
</script>
<style>

.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.fold-botton{
  font-size: 14px;
  color: #1890ff;
  margin-right: 12px;
  cursor: pointer;
}

.small-title{
  font-size: 14px;
  margin: 30px 0;
}
.self-select-box{
  display: inline-block;
  /* margin: 4px 0; */
  padding: 0 4px;
  width: 80px;
  text-align: center;
  border-radius: 5px;
}
.custumer-type .default-people,
.default-people{
  color: #606266;
  background-color:#F4F4F5;
}
.custumer-type .el-select-dropdown__item{
  height: 28px;
  line-height: 28px;
  margin: 5px 0;
}
.custumer-type .el-select-dropdown__item.selected{
  color: #606266;
  font-weight: normal;
  background-color: #ECF5FF;
}
.custumer-type .common-people,
.common-people{
  color: rgb(61, 210, 126);
  background-color: rgb(233, 247, 239);
}
.custumer-type .important-people,
.important-people{
  color: rgb(255, 89, 80);
  background-color: rgb(249, 234, 233);
}
.choose-title{
    display: inline-block;
    width: 80px;
    position: absolute;
    z-index: 1000;
    left: 15px;
    top: 6px;
    height: 24px;
    line-height: 24px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
}
.order-create-picker .el-picker-panel__footer .el-button.el-picker-panel__link-btn.el-button--text.el-button--mini  {
  display: none!important;;
}
</style>



// WEBPACK FOOTER //
// src/views/order/create-layout.vue